import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import { isEmpty, clone } from "lodash";
import * as moment from "moment";

// Import Images

import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  ModalFooter,
  Table,
  FormFeedback,
} from "reactstrap";
import Select from "react-select";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";

// Export Modal
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

//Import actions
import {
  getContact as onGetContacts,
  addNewContact as onAddNewContacts,
  updateContact as onUpdateContacts,
  deleteContact as onDeleteContacts,
  resetContactState,
} from "../../../store/actions";
import {
  getCustomer as onGetCustomers,
  resetCustomerState,
} from "../../../store/actions";
import {
  getDealTag as onGetDealTags,
  resetDealTagState,
} from "../../../store/actions";
//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../../Components/Common/TableContainer";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import Loader from "../../../Components/Common/Loader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../../../assets/images/users/user-dummy-img.jpg";
import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";

const CrmContact = () => {
  const dispatch = useDispatch();
  const [isSearch, setIsSearch] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [customerContactList, setCustomerContactList] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [modalMedia, setModalMedia] = useState(false);
  const [dealTagList, setDealTagList] = useState([]);
  const [otherDocImg, setOtherDocImg] = useState([]);
  const {
    contacts,
    isContactCreated,
    isContactSuccess,
    error,
    loading,
    customers,
    dealTags,
  } = useSelector((state) => ({
    contacts: state.Contact.contacts,
    isContactCreated: state.Contact.isContactCreated,
    isContactSuccess: state.Contact.isContactSuccess,
    error: state.Contact.error,
    loading: state.Contact.loading,
    customers: state.Customer.customers,
    dealTags: state.DealTag.dealTags,
  }));

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    }];

  useEffect(() => {
    if (contacts && !contacts.length && !isSearch) {
      dispatch(resetContactState());
      dispatch(onGetContacts({ isCrm: true }));
      dispatch(resetCustomerState());
      dispatch(onGetCustomers());
      dispatch(resetDealTagState());
      dispatch(onGetDealTags());
      setIsSearch(true);
    }
  }, [dispatch, contacts, isSearch]);

  useEffect(() => {
    if (isContactCreated && isContactSuccess) {
      dispatch(resetContactState());
      dispatch(onGetContacts({ isCrm: true }));
    }
  }, [isContactCreated, isContactSuccess, dispatch]);

  useEffect(() => {
    setContact(contacts);
  }, [contacts]);

  useEffect(() => {
    if (!isEmpty(contacts)) {
      setContact(contacts);
      setIsEdit(false);
    }
  }, [contacts]);

  useEffect(() => {
    if (!isEmpty(customers)) {
      var data = [];
      var opt = [];
      var dataC = [];
      var optC = [];
      customers.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
        item.customer_contact.forEach((i, k) => {
          const name = i.name;
          const id = i.id;
          var obj = { label: name, value: id };
          optC.push(obj);
        });
      });
      var option = { options: opt };
      data.push(option);
      var optionC = { options: opt };
      dataC.push(optionC);
      setCustomerList(data);
      setCustomerContactList(dataC);
    }
  }, [customers]);

  useEffect(() => {
    if (!isEmpty(dealTags)) {
      var data = [];
      var opt = [];
      dealTags.forEach((item, key) => {
        const tag_name = item.name;
        const id = item.id;
        var obj = { label: tag_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setDealTagList(data);
    }
  }, [dealTags]);

  const [isEdit, setIsEdit] = useState(false);
  const [contact, setContact] = useState([]);

  //delete Conatct
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [modal, setModal] = useState(false);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setContact(null);
    } else {
      setModal(true);
      setTag([]);
      setAssignTag([]);
    }
  }, [modal]);

  // Delete Data
  const handleDeleteContact = () => {
    if (contact) {
      dispatch(onDeleteContacts(contact._id));
      setDeleteModal(false);
    }
  };

  const onClickDelete = (contact) => {
    setContact(contact);
    setDeleteModal(true);
  };

  // Add Data
  const handleContactClicks = () => {
    setContact("");
    setIsEdit(false);
    toggle();
  };

  // Date & Time Format

  const dateFormat = () => {
    var d = new Date(),
      months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    return d.getDate() + " " + months[d.getMonth()] + ", " + d.getFullYear();
  };

  const timeFormat = () => {
    let d = new Date();
    let minutes =
      d.getMinutes().toString().length === 1
        ? "0" + d.getMinutes()
        : d.getMinutes();
    let hours = d.getHours().toString() % 12 || 12;
    hours = hours <= 9 ? (hours = "0" + hours) : hours;
    let ampm = d.getHours() >= 12 ? "PM" : "AM";
    return hours + ":" + minutes + ampm;
  };

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      default:
        setOtherDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      customer: (contact && contact.customer) ?? "",
      customerContact: (contact && contact.customerContact) ?? "",
      lead_score: (contact && contact.lead_score) ?? "",
      tag: contact && contact.tag,
    },
    validationSchema: Yup.object({
      lead_score: Yup.string().required("Please Enter Lead Score"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateContact = {
          id: values.customer.value,
          customerId: values.customer.value,
          customerContactId: values.customerContact.value,
          lead_score: values.lead_score,
          tag: JSON.stringify(values.tag),
          isCrm: true,
        };
        dispatch(onUpdateContacts(updateContact));
        validation.resetForm();
      } else {
        const newContact = {
          id: values.customer.value,
          customerId: values.customer.value,
          customerContactId: values.customerContact.value,
          lead_score: values.lead_score,
          tag: JSON.stringify(values.tag),
          isCrm: true,
        };
        dispatch(onUpdateContacts(newContact));
        validation.resetForm();
      }
      toggle();
    },
  });

  // Update Data
  const handleContactClick = useCallback((arg) => {
      const contact = arg;
      let tag = [];

      if (contact.tag && contact.tag.length) {
        contact.tag.forEach((item) => {
          const tag_name = item.label;
          const id = item.value;
          var obj = { label: tag_name, value: id };
          tag.push(obj);
        });
      }

      setContact({
        id: contact.id,
        customer: {
          label: contact.contact_customer.name,
          value: contact.contact_customer.id,
        },
        customerContact: {
          label: contact.name,
          value: contact.id,
        },
        lead_score: contact.lead_score,
        tag: tag,
      });

      setIsEdit(true);
      toggle();
    }, [toggle]);

  // Node API
  // useEffect(() => {
  //   if (isContactCreated) {
  //     setContact(null);
  //     dispatch(onGetContact());
  //   }
  // }, [
  //   dispatch,
  //   isContactCreated,
  // ]);

  const handleValidDate = (date) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  const handleValidTime = (time) => {
    const time1 = new Date(time);
    const getHour = time1.getUTCHours();
    const getMin = time1.getUTCMinutes();
    const getTime = `${getHour}:${getMin}`;
    var meridiem = "";
    if (getHour >= 12) {
      meridiem = "PM";
    } else {
      meridiem = "AM";
    }
    const updateTime =
      moment(getTime, "hh:mm").format("hh:mm") + " " + meridiem;
    return updateTime;
  };

  // Checked All
  const checkedAll = useCallback(() => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".contactCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
    deleteCheckbox();
  }, []);

  // Delete Multiple
  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] = useState(false);

  const deleteMultiple = () => {
    const checkall = document.getElementById("checkBoxAll");
    selectedCheckBoxDelete.forEach((element) => {
      dispatch(onDeleteContacts(element.value));
      setTimeout(() => {
        toast.clearWaitingQueue();
      }, 3000);
    });
    setIsMultiDeleteButton(false);
    checkall.checked = false;
  };

  const deleteCheckbox = () => {
    const ele = document.querySelectorAll(".contactCheckBox:checked");
    ele.length > 0
      ? setIsMultiDeleteButton(true)
      : setIsMultiDeleteButton(false);
    setSelectedCheckBoxDelete(ele);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            className="form-check-input"
            onClick={() => checkedAll()} />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type="checkbox"
              className="contactCheckBox form-check-input"
              value={cellProps.row.original._id}
              onChange={() => deleteCheckbox()}
            />
          );
        },
        id: "#",
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: false,
        Cell: (contact) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0">
                {
                  contact.row.original.image ? (
                    <img
                      src={
                        contact.row.original.image === ""
                          ? logo
                          : `${api.MEDIA_URL}/media/${contact.row.original.image}`
                      }
                      alt=""
                      className="avatar-xxs rounded-circle"
                    />
                  ) : (
                    <div className="flex-shrink-0 avatar-xs me-2">
                      <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">
                        {contact.row.original.name.charAt(0)}
                      </div>
                    </div>
                  )
                  // <img src={dummyImg} alt="" className="avatar-xxs rounded-circle" />
                }
              </div>
              <div className="flex-grow-1 ms-2 name">
                {contact.row.original.name}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Email",
        accessor: "email",
        filterable: false,
      },
      {
        Header: "Lead Score",
        accessor: "lead_score",
        filterable: false,
      },
      {
        Header: "Phone",
        accessor: "phone",
        filterable: false,
      },
      {
        Header: "Position",
        accessor: "position",
        filterable: false,
      },
      {
        Header: "Create Date",
        accessor: "date",
        filterable: false,
        Cell: (cell) => <>{handleValidDate(cell.row.original.createdat)}</>,
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item edit" title="Call">
                <Link to="#" className="text-muted d-inline-block">
                  <i className="ri-phone-line fs-16"></i>
                </Link>
              </li>
              <li className="list-inline-item edit" title="Message">
                <Link to="#" className="text-muted d-inline-block">
                  <i className="ri-question-answer-line fs-16"></i>
                </Link>
              </li>
              <li className="list-inline-item">
                <UncontrolledDropdown>
                  <DropdownToggle
                    href="#"
                    className="btn-soft-secondary btn-sm dropdown"
                    tag="button"> 
                    <i className="ri-more-fill align-middle"></i>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem
                      className="dropdown-item"
                      href="#"
                      onClick={() => {
                        const contactData = cellProps.row.original;
                        setInfo(contactData);
                      }}>
                      <i className="ri-eye-fill align-bottom me-2 text-muted"></i>View
                    </DropdownItem>
                    <DropdownItem
                      className="dropdown-item edit-item-btn"
                      href="#"
                      onClick={() => {
                        const contactData = cellProps.row.original;
                        handleContactClick(contactData);
                      }}>
                      <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>Edit
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </li>
            </ul>
          );
        },
      },
    ],[handleContactClick, checkedAll]);

  const [tag, setTag] = useState([]);
  const [assignTag, setAssignTag] = useState([]);

  const handlestag = (tags) => {
    setTag(tags);
    const assigned = tags.map((item) => item.value);
    setAssignTag(assigned);
  };

  const tags = [
    { label: "Exiting", value: "Exiting" },
    { label: "Lead", value: "Lead" },
    { label: "Long-term", value: "Long-term" },
    { label: "Partner", value: "Partner" }];

  // SideBar Contact Deatail
  const [info, setInfo] = useState([]);

  // Export Modal
  const [isExportCSV, setIsExportCSV] = useState(false);

  document.title = "CRM Contact | Enterprise Resources Planning";
  return (
    <React.Fragment>
      <div className="page-content">
        <ExportCSVModal
          show={isExportCSV}
          onCloseClick={() => setIsExportCSV(false)}
          data={contacts} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteContact}
          onCloseClick={() => setDeleteModal(false)} />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)} />
        <Container fluid>
          <BreadCrumb title="Contact" pageTitle="CRM" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex align-items-center flex-wrap gap-2">
                    <div className="flex-grow-1">
                      <button
                        className="btn btn-info add-btn" onClick={() => {
                          setModal(true);
                        }}>
                        <i className="ri-add-fill me-1 align-bottom"></i> Add
                        Contact
                      </button>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="hstack text-nowrap gap-2">
                        {isMultiDeleteButton && (
                          <button
                            className="btn btn-soft-danger"
                            onClick={() => setDeleteModalMulti(true)}>
                            <i className="ri-delete-bin-2-line"></i>
                          </button>
                        )}
                        <button className="btn btn-danger">
                          <i className="ri-filter-2-line me-1 align-bottom"></i>  Filters
                        </button>
                        <button
                          className="btn btn-soft-success"
                          onClick={() => setIsExportCSV(true)}>Export
                        </button>

                        <UncontrolledDropdown>
                          <DropdownToggle
                            href="#"
                            className="btn btn-soft-info"
                            tag="button">
                            <i className="ri-more-2-fill"></i>
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem className="dropdown-item" href="#">
                              All
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              Last Week
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              Last Month
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              Last Year
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={9}>
              <Card id="contactList">
                <CardBody className="pt-0">
                  <div>
                    {isContactSuccess && contacts.length ? (
                      <TableContainer
                        columns={columns}
                        data={contacts || []}
                        isGlobalFilter={true}
                        isAddUserList={false}
                        customPageSize={8}
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-3"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light"
                        handleContactClick={handleContactClicks}
                        isContactFilter={true}
          SearchPlaceholder="Search for contact..."
                      />
                    ) : (
                      <Loader error={error} />
                    )}
                  </div>

                  <Modal
                    id="showModal"
                    isOpen={modal}
                    toggle={toggle}
                    centered
                    size="md"> 
                    <ModalHeader className="bg-soft-info p-3" toggle={toggle}>
                      {!!isEdit ? "Edit Contact" : "Add Contact"}
                    </ModalHeader>

                    <Form
                      className="tablelist-form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}>
                      <ModalBody>
                        <Input type="hidden" id="id-field" />
                        <Row>
                          <Col lg={12}>
                            <div className="mb-3">
                              <Label
                                htmlFor="name-field"
                                className="form-label">
                                Customer
                              </Label>
                              <Select
                                name="customer"
                                value={validation.values.customer}
                                placeholder="Select Customer"
                                onChange={(e) => {
                                  validation.setFieldValue("customer", e);
                                }}
                                options={customerList}></Select>
                            </div>
                            <div className="mb-3">
                              <Label
                                htmlFor="name-field"
                                className="form-label">
                                Customer Contract
                              </Label>
                              <Select
                                name="customerContact"
                                value={validation.values.customerContact}
                                placeholder="Select Customer Contact"
                                onChange={(e) => {
                                  validation.setFieldValue(
                                    "customerContact",
                                    e
                                  );
                                }}
                                options={customerContactList}></Select>
                            </div>
                            <div className="mb-3">
                              <Label
                                htmlFor="lead_score-field"
                                className="form-label">
                                Lead Score
                              </Label>

                              <Input
                                name="lead_score"
                                id="lead_score-field"
                                className="form-control"
                                placeholder="Enter Lead Score"
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.lead_score ?? ""}
                                invalid={
                                  validation.touched.lead_score &&
                                  validation.errors.lead_score
                                    ? true
                                    : false
                                } />
                              {validation.touched.lead_score &&
                              validation.errors.lead_score ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.lead_score}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <p className="mb-0">
                                {/* <Link
                                to="#"
                                  clas  sName="float-end text-decoration-underline"
                                  onClick={() => toggleTag()}>
                                  Tambah
                                </Link>  */}
                                <label>Deal Tag</label>
                              </p>
                              <Select
                                name="tag"
                                value={validation.values.tag}
                                placeholder="Select deal tag"
                                isMulti
                                onChange={(opt, { option }) => {
                                  let newOpts = opt;
                                  if (option && option.value === "all") {
                                    let filteredOptions = clone(dealTagList);
                                    filteredOptions =
                                      filteredOptions[0].options.filter(
                                        (filteredOption) =>
                                          !newOpts.includes(filteredOption)
                                      );
                                    newOpts = newOpts
                                      .concat(filteredOptions)
                                      .filter(
                                        (newOpt) => newOpt.value !== "all"
                                      );
                                  }
                                  validation.setFieldValue("tag", newOpts);
                                }}
                                options={dealTagList}></Select>
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              setModal(false);
                            }}>
                                Close  </button>
                          <button
                            type="submit"
                            className="btn btn-success"
                            id="add-btn">
                                {!!isEdit ? "Update" : "Add Contact"}  </button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                  <ModalInputFile
                    onSelect={handleSelectFile}
                    loading={loading}
                    modal={modalMedia}
                    toggle={toggleMedia}/>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>

            <Col xxl={3}>
              <Card id="contact-view-detail">
                <CardBody className="text-center">
                  <div className="position-relative d-inline-block">
                    <img
                      src={
                        info.image === ""
                          ? logo
                          : `${api.MEDIA_URL}/media/${info.image}`
                      }
                      alt=""
                      className="avatar-lg rounded-circle img-thumbnail"
                    />
                    <span className="contact-active position-absolute rounded-circle bg-success">
                      <span className="visually-hidden"></span>
                    </span>
                  </div>
                  <h5 className="mt-4 mb-1">{info.name ? info.name : "-"}</h5>
                  <p className="text-muted">
                    {info.contact_customer
                      ? info.contact_customer.customer_company.name
                      : "-"}
                  </p>

                  <ul className="list-inline mb-0">
                    <li className="list-inline-item avatar-xs">
                      <Link
                        to="#"
                        className="avatar-title bg-soft-success text-success fs-15 rounded">
                        <i className="ri-phone-line"></i>
                      </Link>
                    </li>
                    <li className="list-inline-item avatar-xs">
                      <Link
                        to="#"
                        className="avatar-title bg-soft-danger text-danger fs-15 rounded">
                        <i className="ri-mail-line"></i>
                      </Link>
                    </li>
                    <li className="list-inline-item avatar-xs">
                      <Link
                        to="#"
                        className="avatar-title bg-soft-warning text-warning fs-15 rounded">
                        <i className="ri-question-answer-line"></i>
                      </Link>
                    </li>
                  </ul>
                </CardBody>
                <CardBody>
                  <h6 className="text-muted text-uppercase fw-semibold mb-3">
                    Personal Information
                  </h6>
                  <p className="text-muted mb-4">
                    {info.contact_customer
                      ? info.contact_customer.description
                      : "-"}
                  </p>
                  <div className="table-responsive table-card">
                    <Table className="table table-borderless mb-0">
                      <tbody>
                        <tr>
                          <td className="fw-medium">Designation</td>
                          <td>{info.position ? info.position : "-"}</td>
                        </tr>
                        <tr>
                          <td className="fw-medium">Email ID</td>
                          <td>{info.email ? info.email : "-"}</td>
                        </tr>
                        <tr>
                          <td className="fw-medium">Phone No</td>
                          <td>{info.phone ? info.phone : "-"}</td>
                        </tr>
                        <tr>
                          <td className="fw-medium">Lead Score</td>
                          <td>{info.lead_score ? info.lead_score : "-"}</td>
                        </tr>
                        {/* <tr>
                          <td className="fw-medium">Tags</td>
                          <td>
                            {(info.tags || ["Lead", "Partner"]).map(
                              (item, key) => (
                                <span
                                  className="badge badge-soft-primary me-1"
                                  key={key}>
                                  {item}
                                </span>
                              )
                            )}
                          </td>
                        </tr> */}
                        <tr>
                          <td className="fw-medium">Last Contacted</td>
                          <td>
                            {info.createdat
                              ? handleValidDate(info.createdat)
                              : "-"}
                            {/* <small className="text-muted">
                              {info.createdat
                                ? handleValidDate(info.createdat)
                                : "-"}
                            </small> */}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CrmContact;
